import { render, staticRenderFns } from "./TimeBall.vue?vue&type=template&id=141ff0ca&scoped=true"
import script from "./TimeBall.vue?vue&type=script&lang=js"
export * from "./TimeBall.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "141ff0ca",
  null
  
)

export default component.exports